import { Box, styled } from "@mui/material";
import FlatCard from "~/components/FlatCard";

export const IconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 30,
  height: 30,
  "& svg": {
    width: "100%",
  },
});

const InteractiveCard = styled(FlatCard)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: 10,
  boxShadow: `
    0 1px 2px rgba(15, 23, 42, 0.03),
    0 0 0 1px rgba(15, 23, 42, 0.04)
  `,
  display: "flex",
  flexDirection: "column",
  overflow: "visible",
  position: "relative",
  transition: "all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1)",
  width: "100%",

  "&:hover": {
    cursor: "pointer",
    transform: "scale(1.02, 1.02)",
    zIndex: 1,
  },

  "&:after": {
    borderRadius: "inherit",
    boxShadow: "0 4px 10px rgba(15, 23, 42, 0.06)",
    content: "''",
    inset: 0,
    opacity: 0,
    position: "absolute",
    transition: "opacity 0.2s cubic-bezier(0.165, 0.84, 0.44, 1)",
    zIndex: -1,
  },

  "&:hover:after": {
    opacity: 1,
  },

  "&[aria-disabled=true]": {
    pointerEvents: "none",
  },
}));
export default InteractiveCard;
